<template>
  <div v-if="show" class="loader-backdrop">
    <div class="spinner"></div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const show = ref(false);
defineExpose({ show }); // allows control from parent/global
</script>

<style scoped>
.loader-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 6px solid #ccc;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
